import { ZERO, ONE, TWO } from '../../../../../../constant/constant.js'
import {
    emailVerify,
    phoneVerify,
    identityVerify,
    landlinePhoneVerify,
} from '../../../../../../constant/formRegular.js'

// 表单数据
export const formData = {
    id: null,
    contacts: '',
    idCard: '',
    userType: TWO,
    createUserFlag: ONE, // 0->是 1->否
    residentPerson: ONE, // 是否驻点人员 0->是 1->否
    onWayContactFlag: ZERO, // 0->否 1->是
    contactsMobile: '',
    contactsPhone: '',
    contactsEmail: '',
    contactsPost: '',
    countryCode: '',
    provinceCode: '',
    cityCode: '',
    contactsAddress: '',
    supplierCode: '',
    delegateFileId: '',
    delegateFileName: '',
    delegateFileUrl: '',
    delegateStartTime: '',
    delegateEndTime: '',
}

// 表单校验规则
export const formRules = {
    contacts: [
        { required: true, message: '请输入姓名', trigger: ['blur', 'change'] },
        { max: 12, message: '姓名不能超过 12 个字符', trigger: ['blur', 'change'] },
        {
            validator: (rule, value, callback) => {
                if (value && value.includes(' ')) {
                    callback(new Error('姓名不能输入空格'))
                } else {
                    callback()
                }
            },
            trigger: ['blur', 'change'],
        },
    ],
    idCard: [
        { required: false, message: '请输入身份证号', trigger: ['blur', 'change'] },
        { pattern: identityVerify, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] },
    ],
    userType: [{ required: true, message: '请选择用户类型', trigger: ['blur', 'change'] }],
    createUserFlag: [{ required: true, message: '请选择开通账号', trigger: ['blur', 'change'] }],
    residentPerson: [{ required: true, message: '请选择是否驻点人员', trigger: ['blur', 'change'] }],
    onWayContactFlag: [{ required: true, message: '请选择是否在途联系人', trigger: ['blur', 'change'] }],
    contactsMobile: [
        { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    contactsPhone: [
        { required: false, message: '请输入联系电话（对公）', trigger: ['blur', 'change'] },
        {
            pattern: landlinePhoneVerify,
            message: '请输入正确格式的座机电话，示例：020-01234567',
            trigger: ['blur', 'change'],
        },
    ],
    contactsEmail: [
        { required: true, message: '请输入公司邮箱（对公）', trigger: ['blur', 'change'] },
        { max: 50, message: '不能超过50个字符', trigger: ['blur', 'change'] },
        {
            validator: (rule, value, callback) => {
                const mailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z.]{2,12}$/
                if (value && !mailReg.test(value)) {
                    callback(new Error('请输入正确格式的公司邮箱'))
                } else {
                    callback()
                }
            },
            trigger: ['blur', 'change'],
        },
    ],
    contactsPost: [{ required: false, message: '请输入职务', trigger: ['blur', 'change'] }],
    countryCode: [{ required: false, message: '请选择国家', trigger: ['blur', 'change'] }],
    provinceCode: [{ required: false, message: '请选择省份', trigger: ['blur', 'change'] }],
    cityCode: [{ required: false, message: '请选择城市', trigger: ['blur', 'change'] }],
    contactsAddress: [{ required: false, message: '请输入详细地址', trigger: ['blur', 'change'] }],
    delegateFileName: [{ required: false, message: '请上传委托函', trigger: ['blur', 'change'] }],
    delegateStartTime: [{ required: false, message: '请选择委派开始时间', trigger: ['blur', 'change'] }],
    delegateEndTime: [{ required: false, message: '请选择委派结束时间', trigger: ['blur', 'change'] }],
}

export const props = {
    openAddOrEditDialog: {
        type: Boolean,
        default() {
            return false
        },
    },
    addOrEdit: {
        type: Boolean,
        default() {
            return false
        },
    },
    id: {
        type: String,
        default() {
            return ''
        },
    },
    supplierCode: {
        type: String,
        default() {
            return ''
        },
    },
    manage: {
        type: Boolean,
        default() {
            return false
        },
    },
    noAccount: {
        type: Boolean,
        default() {
            return false
        },
    },
    hasMainAccount: {
        type: Boolean,
        default() {
            return false
        },
    },
    propertyNature: {
        type: String,
        default() {
            return ''
        },
    },
    approve: {
        type: Boolean,
        default() {
            return false
        },
    },
    supplierTab: {
        type: Object,
        default() {
            return {}
        },
    },
    isLgtPptSup: {
        type: Boolean,
        default() {
            return false
        },
    },
}
